const FieldCouterHeader = () => {
    return ["tradeName", "regulatoryAuthorisation", "territory",
			"formulationIngredients", "directionsForUse", "directionsForStorage", "directionsForDisposal",
			"adverseEffects", "risks", "safetyInformation", "additionalInstructionsLink", "preparationType",
			"manufacturer", "marketedBy", "brand", "colour", "odour", "unNumber", "storageClassificationCode",
			"modeOfActionDescription", "resistanceInformation", "cropRotationGuidance", "cropFailureGuidance",
			"summaryNotes", "otherMandatoryInformation", "labelMetadata", "productPackage", "productActionType",
			"dangerousIngredientsWarning", "successionalCropGuidance", "directionsForTransport",
			"technicalSupportOrganisation", "coformulantsQbaStatement", "materialState", "manufacturingLocation","ipmStatement","storageTemperature","additionalAdvisoryInformation","totalCount"];
  };
  
  export default FieldCouterHeader;
  